import api from '../../../../api.js';

export const doctorStatsApi = {
  getDoctorStats: async (fromDate, toDate) => {
    try {
      // Build query parameters object
      const params = new URLSearchParams();
      
      // Add date parameters if they are provided
      if (fromDate) {
        params.append('fromDate', fromDate);
      }
      if (toDate) {
        params.append('toDate', toDate);
      }
      
      // Construct URL with query parameters
      const queryString = params.toString();
      const url = queryString 
        ? `/api/dispensary/reports/doctor-stats?${queryString}`
        : '/api/dispensary/reports/doctor-stats';
      
      const response = await api.get(url);
      return response.data;
    } catch (error) {
      console.error('Error fetching doctor stats:', error);
      throw error;
    }
  }
};